<template>
  <div class="card" :class="{ map: map }">
    <h4>
      {{ firm.name }}<br />
      {{ firm.firstname }} {{ firm.lastname }}
    </h4>
    <div class="logo">
      <img v-if="firm.logo" :src="logoHost + '/uploads/' + firm.logo" />
      <div v-else class="spacer"></div>
    </div>
    <p>
      <br />
      {{ firm.street }}<br />
      {{ firm.zip }} {{ firm.city }}
    </p>
    <p>
      {{ firm.phone }}<br />
      {{ firm.web }}<br />
      {{ firm.email }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    firm: {
      type: Object
    },
    logoHost: {
      type: String
    },
    map: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  height: 328px;
  h4 {
    height: 80px;
  }
  .logo {
    height: 80px;
    img {
      max-height: 80px;
      max-width: 260px;
      margin: auto;
    }
  }
  .spacer {
    height: 60px;
  }
  &.map {
    height: auto;
    width: auto;
    h4,
    .logo,
    .spacer {
      height: auto;
    }
  }
}
</style>
